<!-- 报名 -->
<template>
    <div >
      <Breadcrumb :title="title" v-if="show" class="bread"/>        
      <div class="detail-wrap">        
        <!-- <div class="mg-b">
          <el-button type="primary" @click="getUserInfo"> 获取登录信息</el-button>                      
        </div> -->
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
          <el-row >
            <el-col class="mg-b">报名信息</el-col>
            <el-col >
              <el-form-item label="选手姓名" prop="realname">
                <el-autocomplete style="width: 100%;"
                class="inline-input"
                v-model="ruleForm.realname"
                :fetch-suggestions="querySearchRealname"
                placeholder="请输入内容"
                :trigger-on-focus="false"
                @select="handleSelectRealname"
              ></el-autocomplete>
                <!-- <el-input v-model="ruleForm.realname" @input="getUserInfoSearch(ruleForm.realname)"
                  placeholder="请输入选手姓名" maxlength="20"/> -->
                  <el-col class="red">{{errorReg1}}</el-col>
              </el-form-item>
            </el-col>            
          </el-row>  
          <el-row >
            <el-col >
              <el-form-item label="手机号码" prop="phone">
                <el-input type="text" v-model="ruleForm.phone" maxlength="11" placeholder="请输入手机号码"
                  @input="handleInput"/>
              </el-form-item>
            </el-col>
          </el-row>     
          <el-row v-if="pubType === '2'">
            <el-col >
              <el-form-item label="搭档姓名" prop="partnerName">
                <el-autocomplete style="width: 100%;"
                class="inline-input"
                v-model="ruleForm.partnerName"
                :fetch-suggestions="querySearchPartnerName"
                placeholder="请输入内容"
                :trigger-on-focus="false"
                @select="handleSelectPartnerName"
              ></el-autocomplete>
              <el-col class="red">{{errorReg2}}</el-col>
                <!-- <el-input v-model="ruleForm.partnerName" @blur="getUserInfoSearch(ruleForm.partnerName,2)"
                  maxlength="20" placeholder="请输入搭档姓名"/>
                <el-col class="red">{{errorReg2}}</el-col>
                <el-select v-model="partnerInfo"  style="width: 100%;" v-if="partnerInfoOption.length>0">
                  <el-option v-for="item in partnerInfoOption" :key="item.value"     
                  :label="item.phone+''+item.role" :value="item.value"></el-option>
                </el-select> -->
              </el-form-item>
            </el-col>
          </el-row> 
          <!-- <el-row v-if="pubType === '2'">
            <el-col >
              <el-form-item label="搭档手机号" prop="phone">
                <el-input type="text" v-model="ruleForm.partnerPhone" 
                maxlength="11" placeholder="搭档手机号"
                 readonly/>
              </el-form-item>
            </el-col>
          </el-row>      -->
          <el-row >
            <el-col>
              <el-form-item label="俱乐部或协会" prop="company">
                <el-input type="text" v-model="ruleForm.company" readonly
                maxlength="30" placeholder="俱乐部或协会">
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>  
          <el-row>
            <el-col class="red">
              <el-form-item>*注册后报名，会员用户会有积分</el-form-item>
            </el-col>
          </el-row>          
          <el-form-item>           
            <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
            <el-button type="success" @click="getUserInfo">登录</el-button>
            <el-button type="danger" @click="registerDialog('ruleForm')">注册</el-button>
            <!-- <el-button @click="resetForm('ruleForm')">重置</el-button> -->
          </el-form-item>
        </el-form>
      </div>
      <!-- 登录 -->
      <el-dialog
        title="用户登录"
        class="dialog-login"
        :visible.sync="dialogVisible"        
        :before-close="handleClose">
        <el-form :model="ruleForm2" :rules="rules2" ref="ruleForm2" label-width="70px">
          <el-form-item label="用户号" prop="userId">
            <el-input type="text" v-model="ruleForm2.userId" maxlength="11" placeholder="账号或手机号码">
            </el-input>
          </el-form-item>
          <el-form-item label="密码" prop="password">
            <el-input v-model="ruleForm2.password" :type="pwType" 
              @input="pwInput" maxlength="16"
               autocomplete="new-password" placeholder="请输入密码">
          </el-input>
          </el-form-item>
        </el-form>        
        <span slot="footer" class="dialog-footer">       
          <el-button type="primary" @click="loginForm('ruleForm2')">确认</el-button>
        </span>
      </el-dialog>
      <!-- 注册 -->
      <el-dialog 
        title="用户注册"
        class="dialog-login"
        :visible.sync="regVisible" 
        :before-close="handleClose2">
        <el-form :model="registerForm" :rules="rules3" ref="registerForm" label-width="70px">
            <el-form-item label="姓名" prop="username"  >
                <el-input   v-model="registerForm.username" placeholder="姓名" maxlength="11"></el-input>
            </el-form-item>
            <el-form-item label="密码" prop="password" >
                <el-input v-model="registerForm.password" :type="pwType" @input="pwInput" maxlength="16"
                    autocomplete="new-password" placeholder="设置密码"></el-input>
            </el-form-item>
            <el-form-item label="手机号" prop="phone"  >
                <el-input v-model="registerForm.phone" placeholder="手机号" @input="handleInputReg"></el-input>
            </el-form-item>
            <el-form-item label="验证码" prop="varifyCode" >
                <el-input v-model="registerForm.varifyCode" placeholder="验证码">
                    <template slot="append">
                        <el-button  @click="sendPhoneCode" :disabled="disabledCode">{{ codeMsg }}</el-button>
                    </template>
                </el-input>
            </el-form-item>                            
            <el-form-item label="地区">
                <el-select v-model="registerForm.provice" style="width:45%" @change="handleChangeArea">
                    <el-option
                        v-for="item in areaList"
                        :key="item.code"
                        :label="item.label"
                        :value="item.label"
                        >
                    </el-option>
                </el-select>
                <el-select v-model="registerForm.city" style="width:45%" @change="handleChangecity">
                    <el-option
                        v-for="item in cityList"
                        :key="item.code"
                        :label="item.label"
                        :value="item.label"
                        >
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" :loading="false" 
                    @click="handleRegister('registerForm')" >注册</el-button>
            </el-form-item>
        </el-form>
      </el-dialog>
    </div>
  </template>
  
  <script>
  import areaList from '@/assets/js/city'
  import Breadcrumb from '@/components/Breadcrumb'
  
  export default {
    name: 'apply',
    components: {
      Breadcrumb
    },
    data() {
      return {     
        areaList: areaList.provinces,
        cityList: [], 
        show: false,
        dialogVisible: false,
        pwType: 'text',
        pwKey: 0,
        loading: false,
        errorReg1: '',
        errorReg2: '',
        flag: 2,
        ruleForm: {
          realname: '',         
          phone: '',   
          company: '',
          companyId: '',
          playerNo: '',
          partnerName: '',
          partnerNo:'',
          partnerPhone: '',
        },
        ruleForm2:{
          userId: '',
          password: ''
        },
        registerForm: {
            username: '',
            password: '',
            phone: '',
            varifyCode: '',
            company:'',   
            provice: '',
            city: '',
        },
        rules: {         
          realname: [
            { required: true, message: '请输入选手姓名', trigger: 'blur' },
            { min: 2, max: 20, message: '长度在 2 到 20 个字符', trigger: 'blur' }
          ],         
          phone: [
            { required: true, message: '请输入手机号', trigger: 'blur' },
            { min: 3, max: 11, message: '长度在11个字符', trigger: 'blur' }
          ],        
        },
        rules2: {
          userId: [
              { required: true, message: '请输入用户号', trigger: 'blur' },
              { min: 1, max: 11, message: '长度在 1 到 11 个数字', trigger: 'blur' }
          ],
          password: [
              { required: true, message: '请输入密码', trigger: 'blur' },
              { min: 1, max: 16, message: '长度在 1 到 16 个字符', trigger: 'blur' }
          ],
        },
        rules3:{
              username: [
                  { required: true, message: '请输入用户名', trigger: 'blur' },
                  { min: 1, max: 10, message: '长度在 1 到 10 个字符', trigger: 'blur' }
              ],
              password: [
                  { required: true, message: '请输入密码', trigger: 'blur' },
                  { min: 1, max: 16, message: '长度在 1 到 16 个字符', trigger: 'blur' }
              ],
              phone: [
                  { required: true, message: '请输入手机号', trigger: 'blur' },
                  { min: 3, max: 11, message: '长度在 11 位字符', trigger: 'blur' }
              ],
              varifyCode: [
                  { required: true, message: '请输入验证码', trigger: 'blur' },
                  { min: 3, max: 6, message: '长度在 3 到 6 个字符', trigger: 'blur' }
              ],
        },
        clientWidth: '',
        publishId: '',
        pubType: '',
        regVisible: false,
        disabledCode: false,
        codeMsg: '发送验证码',
        seconds: 60,
        timer: null,
        partnerInfo: '',
        userInfoOption: [],
        partnerInfoOption: [],
        partnerName:'',
        totalFee: 0
      }
    },
    created() {
        window.addEventListener('resize', this.handleResize); 
        this.publishId = this.$route.query.id
        this.pubType = this.$route.query.type
    },
    mounted() {
      this.handleResize()
      this.getQuery()
    },
    watch:{      
      clientWidth(){             
        if(this.clientWidth > 768){
          this.show = true
        }else{
          this.show = false
        }        
      },
      'ruleForm.realname'(v){
        if(v===''){
          this.ruleForm.phone = ''
          this.ruleForm.playerNo = ''
          this.userInfoOption = []
          this.errorReg1 = ''
        }        
      },
      'ruleForm.partnerName'(v){
        if(v===''){
          this.partnerInfoOption =[]
          this.ruleForm.partnerNo = ''
          this.ruleForm.partnerPhone = ''
          this.errorReg2 = ''
        }     
      }, 
    },
    computed: {
      title() {
        return this.$route.meta.title
      },
    },
    methods: {   
      getQuery(){
        let params = {
                opcode: this.$code.PublishQuery,
                i_serial_mark: this.publishId,
                c_status: '',
                v_type: '',
                v_theme: '',
                start_date: '',
                end_date: '',
                pagesize: 10,
                page: 1,
            }
            this.$api._requestAPI(params).then(res =>{
              if (res.IsSuccess) {
                  let result = res.Data.DataTable
                  let list  = result.map(item=>{
                      return{
                        price: item['报名费用']
                      }
                  })
                  this.totalFee = list[0].price
                }
           })
      },    
      initData(){
        let params = {
              opcode: this.$code.UserInfo
          }
          // 查询账户信息
          this.$api.requestAPI(params).then(res => {
              if (res.IsSuccess) {
                let result = res.Data.DataTable[0]
                this.ruleForm.realname = result['姓名'];
                this.ruleForm.phone  = result['手机号'];
                this.ruleForm.playerNo = result['选手账号']
              }
          }).catch(err => {
              this.$message.error("登录失败，请重新登录")
          })
      },
      getUserInfo(){
        this.dialogVisible = true
      },    
      getGuest(){
        this.flag = 2
        this.ruleForm.playerNo = ''
        this.ruleForm.realname = ''
        this.ruleForm.phone = ''
        this.ruleForm.company = ''
      }, 
      sendPhoneCode() {
          if (this.registerForm.phone == '') {
              this.$message.error('请输入手机号');
              return false;
          }
          if (!this.$help.isMobile(this.registerForm.phone)) {
              this.$message.error('请输入正确的手机号');
              return false;
          }
          let params = {
              opcode: this.$code.SMS,
              v_phone: this.registerForm.phone,
          }

          this.$api._requestAPI(params).then(res => {
              if (res.IsSuccess) {
                  this.$message.success('发送成功')
              } else {
                  this.$message.error(res.Message)
              }
          }).catch(err => {
              console.log(err);
          })

          this.timer = setInterval(() => {
              if (this.seconds == 0) {
                  clearInterval(this.timer);
                  this.disabledCode = false;
                  this.codeMsg = '重新发送';
                  this.seconds = 60;
              } else {
                  this.seconds--
                  this.disabledCode = true;
                  this.codeMsg = this.seconds + '秒后重发'
              }
          }, 1000)
      },
      handleClose(){
        this.dialogVisible = false
        this.resetForm('ruleForm2')
        
      },
      handleClose2(){
        this.regVisible = false
        this.resetForm('registerForm')
      },
      submitForm(formName) {
        if(this.totalFee > 0){
          this.$message.error('请到掼一把小程序报名！')
          return false
        }
        if(this.pubType === '2'){
          if(this.ruleForm.playerNo === ''){
            this.$message.error('未注册，选手注册后再报名！')
            this.ruleForm.phone = ''
            return false
          }
          if(this.ruleForm.partnerNo === ''){
            this.$message.error('未注册，搭档注册后再报名')
            this.ruleForm.partnerPhone = ''
            return false
          }
          if(this.ruleForm.playerNo === this.ruleForm.partnerNo){
            this.$message.error('选手和搭档不能为同一个人！')
            return false
          }
        }else if(this.pubType === '1'){
          if(this.ruleForm.playerNo === ''){
            this.$message.error('未注册，选手注册后再报名！')
            this.ruleForm.phone = ''
            return false
          }  
        }
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.handleSubmit()
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      resetForm(formName) {
          this.$refs[formName].resetFields();
      },
      handleSubmit() {
          let { realname,  phone, company, companyId,playerNo, partnerName,partnerNo,partnerPhone} = this.ruleForm
          let code = this.flag === 1 ? this.$code.ApplyCode : this.$code.ApplyGuest
          let params = {
            opcode: code,
            i_serial_mark: this.publishId,
            v_player_no: playerNo, 
            v_player_name: realname,
            v_player_phone: phone,
            v_partner_no: partnerNo,
            v_partner_name: partnerName,
            v_partner_phone: partnerPhone,
            v_player_association: company,
            v_player_association_no: companyId,               
          };
          this.$api._requestAPI(params).then(res => {
            if (res.IsSuccess) {                
                if(this.pubType === '2'){
                  this.$message.success('报名成功，请自行联系您的搭档共同参与比赛！')
                }else{
                  this.$message.success('报名成功') 
                }
                setTimeout(()=>{
                  this.$router.go(-1)  
                },1000)
            } else {
                this.$message.error(res.Message)
            }
          })   
      },    
      loginForm(formName){
        let { userId, password } = this.ruleForm2;
            let type = this.$help.isMobile(userId) ? 'PhonePassword' : 'UserCode';
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    let params = {
                        opcode: this.$code.LoginCode,
                        login_type: type,
                        clientno: userId,
                        password: password
                    }
                    this.$api.login(params).then(res => {
                        let data = res.data;
                        if (data.IsSuccess) {
                            localStorage.isLogin = 0;
                            localStorage.token = data.Tag;
                            localStorage.userId = userId
                            this.dialogVisible = false
                            setTimeout(() => { this.accountInfo() }, 0)
                        } else {
                            this.$message.error(data.Message)
                        }
                    }).catch(err => {
                        this.$message.error("登录失败，请重新登录")
                    })
                } else {
                    console.log('error submit!!');
                    return false;
                }
            })
      },  
      accountInfo() {
            let params = {
                opcode: this.$code.UserInfo
            }
            // 查询账户信息
            this.$api.requestAPI(params).then(res => {
                if (res.IsSuccess) {
                    let result = res.Data.DataTable[0]
                    localStorage.roles = result['角色']
                    localStorage.playerNo = result['选手账号'];
                    this.ruleForm.realname = result['姓名'];
                    this.ruleForm.phone  = result['手机号'];
                    this.ruleForm.playerNo = result['选手账号'];
                    this.$message.success('登录成功');
                }
            }).catch(err => {
                this.$message.error("登录失败，请重新登录")
            })
        },
      pwInput(e) {
          if (e) {
          this.pwType = 'password'
          } else {
          this.pwKey++
          this.pwType = 'text'
          }
      },
      toNotice() {
          this.$router.push('/notice')
      },
      handleResize(){
        this.clientWidth = window.innerWidth || document.body.clientWidth;
      },
      registerDialog(){
        this.regVisible = true
      },
      handleRegister(formName){
        let { username, password,phone, varifyCode,company,provice,city} = this.registerForm;
          this.$refs[formName].validate((valid) => {
              if (valid) {
                  let params = {
                      opcode: this.$code.RegisterCode,
                      v_name: username,
                      v_company: company,
                      v_order_pass: password,
                      v_phone: phone,
                      v_verify_code: varifyCode,
                      //非必填字段 
                      v_caption: '',
                      v_nickName: '',
                      openId: '',
                      unionId: '',
                      i_voucher_up_image: '',
                      i_voucher_down_image: '',
                      i_avatar_image: '',
                      v_synopsis: '',   
                      v_details: '',
                      v_summary: '',  
                      v_provice:  provice,
                      city: city                       
                  }
                  this.$api._requestAPI(params).then(res => {
                      if (res.IsSuccess) {
                          setTimeout(() => {                                
                              this.$message.success(res.Message)
                              this.regVisible = false
                              this.resetForm('registerForm')
                          }, 500);
                      } else {
                          this.$message.error(res.Message)
                      }
                  }).catch(err => {
                      this.$message.error(err)
                  })
              } else {
                  console.log('error submit!!');
                  return false;
              }
          })
      },
      // 模糊搜索查询 获取搭档的个人信息 手机号和俱乐部
      getUserInfoSearch(){
        return new Promise((resolve,reject)=>{
          let params = {
            opcode: this.$code.UserInfoSearch,
            v_name: this.ruleForm.realname,
            v_caption: '',
            v_phone: '',
        }
        // 查询账户信息
        this.$api._requestAPI(params).then(res => {
            if (res.IsSuccess) {
                let result = res.Data.DataTable
                if(result.length > 0){
                    // this.errorReg1 = '未注册，建议注册后报名有积分'
                    // this.ruleForm.phone = ''  
                    // this.ruleForm.playerNo = ''    
                    // this.ruleForm.phone  =  this.userInfoOption[0].phone;
                    // this.ruleForm.playerNo = this.userInfoOption[0].value
                    this.errorReg1 = ''
                    let list = result.map(item=>{
                      return{
                          value:item['手机号']+''+ item['角色'],
                          label: item['会员账号'],
                          phone: item['手机号'],
                          role: item['角色'],
                          username: item['姓名']
                      }
                    }) 
                    let arr = list.filter(i=>i.role === '选手')
                    this.userInfoOption =  arr
                    if(arr.length === 0){
                        this.errorReg1 = '未注册，建议注册后报名有积分!'
                        this.ruleForm.company = ''
                        this.ruleForm.companyId = ''
                    }
                    resolve(arr)
                }else{  
                  this.userInfoOption = []   
                  if(this.userInfoOption.length === 0){
                    this.errorReg1 = '未注册，建议注册后报名有积分!'
                    this.ruleForm.company = ''
                    this.ruleForm.companyId = ''                    
                  }else{
                    this.errorReg1 = ''                    
                  }
                  resolve([])
              }
            }
        }).catch(err => {
          reject(err)
        })
        })       
      },
      // 获取搭档信息
      fetchData(){        
        return new Promise((resolve,reject)=>{
          let params = {
            opcode: this.$code.UserInfoSearch,
            v_name: this.ruleForm.partnerName,
            v_caption: '',
            v_phone: '',
          }
          // 查询账户信息
          this.$api._requestAPI(params).then(res => {
              if (res.IsSuccess) {
                  let result = res.Data.DataTable                  
                  if(result.length > 0){                   
                      this.errorReg2 = ''
                      let list = result.map(item=>{
                        return{
                            value:item['手机号']+''+ item['角色'],
                            label: item['会员账号'],
                            phone: item['手机号'],
                            role: item['角色'],
                            username: item['姓名']
                        }
                      }) 
                      let arr  = list.filter(i=>i.role === '选手') 
                      this.partnerInfoOption = arr
                      if(arr.length === 0){
                        this.errorReg2 = '未注册，搭档注册后再报名'
                      }
                      resolve(arr) 
                  }else{
                    this.partnerInfoOption = []
                    if(this.partnerInfoOption.length ===0){
                        this.errorReg2 = '未注册，搭档注册后再报名'
                      }else{
                        this.errorReg2 = ''
                      }
                    resolve([]) 
                  }
              }
          }).catch(err => {
            reject(err)
          })
        })      
      },
      async querySearchPartnerName(queryString, cb){
        let result = queryString ? await this.fetchData() : []  
        cb(result)
      },
      handleSelectPartnerName(item){       
        this.ruleForm.partnerPhone = item.phone
        this.ruleForm.partnerName = item.username
        this.ruleForm.partnerNo = item.label
        this.partnerShow = true
      },
      async querySearchRealname(queryString, cb){
        let result = queryString ? await this.getUserInfoSearch() : []  
        cb(result)
      },
      handleSelectRealname(item){       
        this.ruleForm.phone = item.phone
        this.ruleForm.realname = item.username
        this.ruleForm.playerNo = item.label
        this.playerShow = true
        // this.ruleForm.company = ''
        // this.ruleForm.companyId = ''
        if(this.ruleForm.playerNo){
          this.getClubQuery(item.label)
        }
      },
      handleChangeArea(value){
          this.cityList = []
          this.registerForm.provice = value
          this.registerForm.city = ''
          let cityObj = this.areaList.filter(i=> i.label === value)
          this.cityList = cityObj[0].cities
      },
      handleChangecity(value){
          this.registerForm.city = value
      },
      // 只能输入数字，限制输入其它字符
      handleInput(value){
        const pattern = /^[0-9]\d*$/g
        if (pattern.test(value)) {
            // 双向绑定
            this.ruleForm.phone = value
        } else {
            // 输入值不为正整数，则从中提取出数字并拼接为字符串，赋值给username
            const num = value.match(/\d+/g)
            this.ruleForm.phone = num ? num.join('') : ''
        }
      },
      handleInputReg(value){
        const pattern = /^[0-9]\d*$/g
        if (pattern.test(value)) {
            // 双向绑定
            this.registerForm.phone = value
        } else {
            // 输入值不为正整数，则从中提取出数字并拼接为字符串，赋值给username
            const num = value.match(/\d+/g)
            this.registerForm.phone = num ? num.join('') : ''
        }
      },
      getClubQuery(){
        let params = {
            opcode: this.$code.UserAssociation,
            i_client_no: this.ruleForm.playerNo,
          }
          // 查询账户信息
          this.$api._requestAPI(params).then(res => {
              if (res.IsSuccess) {
                let arr = res.Data.DataTable
                console.log(arr)
                if(arr.length > 0 ){
                  let list = arr.map(item=>{
                    return{
                      company: item['协会(俱乐部)简称'],
                      companyId: item['协会(俱乐部)账号'],
                    }
                  })
                  this.ruleForm.company = list[0].company
                  this.ruleForm.companyId = list[0].companyId
                }else{
                  this.ruleForm.company = ''
                  this.ruleForm.companyId = ''
                }
              }
          })
      }
    },
    destroyed(){
      window.removeEventListener('resize', this.handleResize);
    }
  }
  </script>
  <style lang='scss' scoped>
  @import '@/assets/css/style.scss';
 
  .inputTxt>>>.el-input-group__append {
    background-color: #409EFF !important;
    color: #fff;
  }
  .mg-b {
    margin-bottom: 15px;
  }
@media screen and (min-width: 769px){
  .bread{
    margin: 30px 0 0 215px;
  }
  .detail-wrap{   
    width: 750px; 
    .el-row{
      width: 50%
    }    
  }
  .dialog-login >>> .el-dialog{
        width: 30%
    }
}
@media screen and (max-width:768px){
  .detail-wrap{
    width: 80vw;
    margin-top: 0;
    padding: 30px;
    border: 0;
  }
  .dialog-login >>> .el-dialog{
    width: 50vh ;
  }
}
  </style>


// WEBPACK FOOTER //
// src/views/publish/apply.vue